import Component from './component';
import { deepGet } from './utils';

export default class Context extends Component {
  constructor() {
    super();

    this.data = {};

    this.config = {
      maxTries: 100,
    };
  }

  waitForData(path, triesLeft = this.config.maxTries) {
    return new Promise((resolve, reject) => {
      const value = deepGet(this.data, path);

      if (typeof value !== 'undefined') {
        return resolve(value);
      }

      if (triesLeft === 0) {
        return reject(`Could not get context data after ${this.config.maxTries} tries`);
      }

      setTimeout(() => {
        resolve(this.waitForData(path, triesLeft - 1));
      }, 500);
    });
  }

  get(path) {
    return this.waitForData(path);
  }

  set(data) {
    this.data = data;
  }
}
